import React, { createContext, useContext, useState, useEffect } from 'react';

const InquiryContext = createContext();

export const InquiryProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem('aartema_inquiry_cart');
    return savedCart ? JSON.parse(savedCart) : [];
  });

  useEffect(() => {
    localStorage.setItem('aartema_inquiry_cart', JSON.stringify(cart));
  }, [cart]);

  const addToInquiry = (product, quantity = 1, notes = '') => {
    setCart((prevCart) => {
      const exists = prevCart.find((item) => item.id === product.id);
      if (exists) {
        return prevCart.map((item) =>
          item.id === product.id ? { ...item, quantity: item.quantity + quantity } : item
        );
      }
      return [...prevCart, { ...product, quantity, customNotes: notes }];
    });
  };

  const removeFromInquiry = (id) => {
    setCart((prevCart) => prevCart.filter((item) => item.id !== id));
  };

  const updateQuantity = (id, amt) => {
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.id === id ? { ...item, quantity: Math.max(1, item.quantity + amt) } : item
      )
    );
  };

  const updateItemNotes = (id, notes) => {
    setCart((prevCart) =>
      prevCart.map((item) => (item.id === id ? { ...item, customNotes: notes } : item))
    );
  };

  const clearInquiry = () => setCart([]);

  return (
    <InquiryContext.Provider value={{ cart, addToInquiry, removeFromInquiry, updateQuantity, updateItemNotes, clearInquiry }}>
      {children}
    </InquiryContext.Provider>
  );
};

export const useInquiry = () => useContext(InquiryContext);
